


















































import { Component, Prop, Vue } from "vue-property-decorator";
import { getAllUserGroups } from "@/services/users/userGroupService";
import { MonitorSubscriber, SubscriberType } from "@/services/players/types";
import { getUsers } from "@/services/users/usersService";
import { addSubscribersFields } from "@/components/players/fields/subscribersFields";

@Component
export default class SelectSubscribersModal extends Vue {
    @Prop() existingSubscribers!: MonitorSubscriber[];
    subscribers = [] as MonitorSubscriber[];
    selectedSubscribers = [] as MonitorSubscriber[];
    selectedItems = [] as MonitorSubscriber[];
    searchQuery = "";
    fields = addSubscribersFields;
    // computed
    get filteredData() {
        return this.subscribers && this.subscribers
            .filter(x => this.searchQuery.length === 0 || (x.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
                x.email.toLowerCase().includes(this.searchQuery.toLowerCase())));
    }

    // methods
    fetchData() {
        this.subscribers = [];
        this.setSelectedItemsArray();
        getAllUserGroups()
            .then(response => {
                this.subscribers = this.subscribers.concat(response.map(x => ({
                    id: x.id,
                    name: x.name,
                    type: SubscriberType.UserGroup,
                    email: ""
                } as MonitorSubscriber)));
            });
        getUsers().then(response => {
            this.subscribers = this.subscribers.concat(response
                .map(x => ({
                    id: x.id,
                    name: x.name,
                    email: x.email,
                    type: SubscriberType.User
                } as MonitorSubscriber)));
        });
    }

    select(items: MonitorSubscriber[]) {
        this.selectedItems = items;
    }

    setSelectedItemsArray() {
        this.selectedSubscribers = [];
        this.selectedSubscribers =
            this.selectedSubscribers
                .concat(this.existingSubscribers);
    }

    save() {
        this.selectedItems.forEach(sItem => {
            const item = this.subscribers.find(x => x.id === sItem.id);
            if (!item) { return; }
            const selectedItem = this.selectedSubscribers.find(x => x.id === item.id);
            if (!selectedItem) {
                this.selectedSubscribers.push(item);
            }
        });
        this.$emit("select", this.selectedSubscribers);
        this.$bvModal.hide("modal-reportSubscribers");
    }

    open() {
        this.fetchData();
        this.$bvModal.show("modal-reportSubscribers");
    }
}
